module.exports = __webpack_public_path__ + "static/img/carousel_3.d6c4bb83.jpg";